__webpack_require__.p = "/foodkiosk/";